<mat-chip-list [ngClass]="{'fragment-saving-chip': true, long: delayed}" selectable="false" *ngIf="shouldDisplay()">
  <mat-chip [color]="errors ? 'warn' : 'primary'" selected="true">{{ getSavingMessage() }}</mat-chip>
</mat-chip-list>
